export const ADVERTISEMENT_SUGGESTIONS_COST = 2;
export const ADVERTISEMENT_DETAILS_COST = 3;

export const ARTICLE_TITLES_COST = 2;
export const ARTICLE_CONTENT_COST = 10;

export const CASUAL_RESPONSE_COST = 4;

export const DIET_SUGGESTIONS_COST = 5;
export const DIET_DETAILS_COST = 12;

export const FACEBOOK_SUGGESTIONS_COST = 2;
export const FACEBOOK_POST_COST = 2;

export const LEGAL_ADVICE_COST = 10;
export const LEGAL_DOCUMENT_COST = 10;

export const REELS_SUGGESTIONS_COST = 2;
export const REELS_DETAILS_COST = 2;

export const SEARCH_SUGGESTIONS_COST = 12;
export const SEARCH_DETAILS_COST = 15;

export const SOCIAL_MEDIA_SUGGESTIONS_COST = 2;
export const SOCIAL_MEDIA_DETAILS_COST = 2;
export const SOCIAL_MEDIA_COMMENT_COST = 2;

// Note: Image & Video bots do not currently use the standard token deduction on the backend.
// These values are for display purposes only on the frontend.
export const MUSIC_GENERATION_COST = 40;
export const IMAGE_FLUX_SCHNELL_COST = 12;
export const IMAGE_ESSENTIAL_V2_COST = 30;
export const VIDEO_MINIMUM_COST = 50;
export const VIDEO_STANDARD_COST = 70;
export const VIDEO_PREMIUM_COST = 150;